/* Product page helpers:
   - mobile sticky "Add to cart" bar (snippets/tt-sticky-atc.liquid): visible while the main buttons are off
     screen; mirrors price and sold-out state; clicking it clicks the main Add to cart button;
   - "Size guide" link (snippets/tt-pdp-trust.liquid, part 'fit'): opens and scrolls to the Sizing accordion. */
(function () {
	if (window.ttStickyAtc) return;
	window.ttStickyAtc = true;

	function sizeGuide() {
		document.addEventListener('click', (e) => {
			const link = e.target.closest('[data-tt-size-guide]');
			if (!link) return;
			e.preventDefault();
			const item = [...document.querySelectorAll('.product-about__accordion-item')].find((i) => /siz/i.test(i.querySelector('.product-about__accordion-title')?.innerText || ''));
			if (!item) return;
			const content = item.querySelector('.product-about__accordion-content');
			if (content && getComputedStyle(content).display === 'none') item.querySelector('.product-about__accordion-title').click();
			item.scrollIntoView({ behavior: 'smooth', block: 'center' });
		});
	}

	function sticky(bar) {
		const sectionId = bar.dataset.section;
		const main = document.getElementById('ProductSubmitButton-' + sectionId);
		if (!main) return;
		const btn = bar.querySelector('[data-tt-sticky-btn]');
		const priceOut = bar.querySelector('[data-tt-sticky-price]');
		const priceEl = document.getElementById('price-' + sectionId);
		const mq = window.matchMedia('(max-width: 749px)');
		const watch = main.closest('.product-form__buttons') || main;

		const syncPrice = () => {
			if (!priceEl) return;
			const item = [...priceEl.querySelectorAll('.price-item')].find((p) => p.offsetParent && p.innerText.trim());
			if (item) priceOut.textContent = item.innerText.trim();
		};
		const syncState = () => {
			const off = main.disabled || main.hasAttribute('disabled');
			btn.disabled = off;
			btn.textContent = (main.querySelector('span')?.innerText || main.innerText).trim();
		};

		let mainVisible = true;
		const update = () => {
			const show = mq.matches && !mainVisible && !document.body.classList.contains('overflow-hidden');
			bar.classList.toggle('is-visible', show);
			bar.setAttribute('aria-hidden', show ? 'false' : 'true');
			btn.tabIndex = show ? 0 : -1;
			document.body.classList.toggle('tt-sticky-atc-on', show);
		};

		new IntersectionObserver((entries) => {
			mainVisible = entries[0].isIntersecting;
			update();
		}).observe(watch);
		// The cart drawer and modals lock the body with .overflow-hidden; hide the bar while they are open.
		new MutationObserver(update).observe(document.body, { attributes: true, attributeFilter: ['class'] });
		mq.addEventListener('change', update);
		if (priceEl) new MutationObserver(syncPrice).observe(priceEl, { childList: true, subtree: true, characterData: true });
		new MutationObserver(syncState).observe(main, { attributes: true, attributeFilter: ['disabled'], childList: true, subtree: true });
		syncPrice();

		btn.addEventListener('click', () => {
			if (btn.disabled) return;
			main.click();
			// If the main form reports a problem (e.g. a required personalisation field), bring it into view.
			setTimeout(() => {
				const form = main.closest('product-form');
				const err = form && form.querySelector('.product-form__error-message-wrapper:not([hidden])');
				const invalid = document.querySelector('#product-form-' + sectionId + ' :invalid, [form="product-form-' + sectionId + '"]:invalid');
				if (err || invalid) watch.scrollIntoView({ behavior: 'smooth', block: 'center' });
			}, 700);
		});
	}

	const run = () => {
		sizeGuide();
		document.querySelectorAll('[data-tt-sticky-atc]').forEach(sticky);
	};
	if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
	else run();
})();
